// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lesson-output[data-v-fe1b8914] {\n  width: 100%;\n}\n.lesson-output__top[data-v-fe1b8914] {\n  width: 100%;\n}\n.lesson-output__bottom[data-v-fe1b8914] {\n  width: 100%;\n  height: calc(100vh - 110px);\n  border: none;\n  color: #fff;\n  background-color: #191b24;\n  padding: 10px;\n  overflow: scroll;\n}\n.lesson-output__bottom[data-v-fe1b8914]::-webkit-scrollbar {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
